
import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import TextEditorHorizontalRuleWrapper from './styles/TextEditorHorizontalRuleWrapper';

export default function HorizontalRuleComponent(props) {
  return (
    <NodeViewWrapper className="hr-item" onMouseUp={() => {
        const nodePosition = props.getPos();
        props.editor.commands.setNodeSelection(nodePosition);
      }} 
    >
      <TextEditorHorizontalRuleWrapper borderColor={props.node.attrs.borderColor} borderWidth={props.node.attrs.borderWidth} borderWidthUnit={props.node.attrs.borderWidthUnit} contentEditable={true} />
    </NodeViewWrapper>
  )
}



